import { PropTypes } from "prop-types";

export const ImageShape = {
    url: PropTypes.string.isRequired,
    alternativeText: PropTypes.string,
    name: PropTypes.string,
};

export default ImageShape;
